import { CheckCouponForPaymentResponse } from '@entities/coupon'
import { podoFetcher } from '@server/infrastructure/external-apis/podo/client'
import { BaseResponseSchema, RawCoupon } from '@server/schemas'

export const couponEntityMutations = {
  publishCoupon: ({ bearerToken, subscribeId }: RequestQueryOptions<{ subscribeId?: string }>) => ({
    mutationKey: [bearerToken, subscribeId],
    mutationFn: async ({ couponCode }: { couponCode: string }) =>
      await podoFetcher<BaseResponseSchema<RawCoupon | RawCoupon[]>>({
        method: 'POST',
        url: `/api/v1/coupon/publishCoupon?subscribeIdOrNull=${subscribeId ?? null}`,
        header: {
          Authorization: `Bearer ${bearerToken}`,
        },
        body: { template_code: couponCode },
      }).then(async (res) => res.data),
  }),
  checkCouponForPayment: ({
    bearerToken,
    couponId,
    subscribeId,
    productId,
  }: {
    bearerToken: string
    couponId: Nullable<string>
    subscribeId: string
    productId?: string | null
  }) => ({
    mutationKey: [bearerToken, couponId, subscribeId, productId],
    mutationFn: async () => {
      const searchParams = new URLSearchParams({
        couponId: couponId ?? '',
        subscribeId,
      })
      if (productId) {
        searchParams.set('productId', productId)
      }
      return await podoFetcher<CheckCouponForPaymentResponse>({
        method: 'GET',
        url: `/api/v1/coupon/canUseCoupon?${searchParams.toString()}`,
        header: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }).then(async (res) => res.data)
    },
  }),
}
